import {crud} from 'app/lib/action';
import {GET_GOODS} from '../constants/actionTypes';

export default crud(GET_GOODS);